import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=791141ed&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=791141ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791141ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791141ed')) {
      api.createRecord('791141ed', component.options)
    } else {
      api.reload('791141ed', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=791141ed&scoped=true&", function () {
      api.rerender('791141ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27CsPKTExLyLS/JS/comp/GuestBox.vue"
export default component.exports